import type { MessageDescriptor } from 'react-intl';
import { defineMessages } from 'react-intl';

// Toast copy for a failed "Revoke admin access". `useTeamApi.cancelPendingRoles`
// throws these codes; any other error gets the generic message.
export const CANCEL_PENDING_ROLE_ERROR_CODES = {
  alreadyApplied: 'CANCEL_PENDING_ROLE_ALREADY_APPLIED',
  permissionDenied: 'CANCEL_PENDING_ROLE_PERMISSION_DENIED',
} as const;

export const cancelPendingRoleErrorMessages = defineMessages({
  alreadyEffective: {
    id: 'Team.cancelPendingRoleErrors.alreadyEffective',
    defaultMessage: 'This role change already took effect.',
    description:
      'Toast shown when cancelling a pending role change fails because the grace period already ended and the role is in effect',
  },
  permissionDenied: {
    id: 'Team.cancelPendingRoleErrors.permissionDenied',
    defaultMessage: "You don't have permission to cancel this role change.",
    description:
      "Toast shown when cancelling a pending role change fails because the caller lacks permission for the member's legal entities",
  },
  generic: {
    id: 'Team.cancelPendingRoleErrors.generic',
    defaultMessage: "Couldn't cancel the role change. Try again.",
    description:
      'Fallback toast shown when cancelling a pending role change fails with an unrecognized backend error',
  },
});

const RAW_ERROR_TO_MESSAGE: ReadonlyMap<string, MessageDescriptor> = new Map([
  [CANCEL_PENDING_ROLE_ERROR_CODES.alreadyApplied, cancelPendingRoleErrorMessages.alreadyEffective],
  [
    CANCEL_PENDING_ROLE_ERROR_CODES.permissionDenied,
    cancelPendingRoleErrorMessages.permissionDenied,
  ],
]);

export function getCancelPendingRoleErrorMessage(rawError: string | undefined): MessageDescriptor {
  if (!rawError) return cancelPendingRoleErrorMessages.generic;
  return RAW_ERROR_TO_MESSAGE.get(rawError) ?? cancelPendingRoleErrorMessages.generic;
}
